// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"93b4724e","213":"5013e75b","778":"db66af33","965":"b0507ca4"}[chunkId] + ".chunk.js";
};